<template>
  <div class="device">
    <div class="layout" style="margin-top:5.9375rem;">
      <div class="device-setting">
        <div class="layout-header" ref="searchBox" style="background:transparent;padding:1rem;width: calc(100% - 0.875rem);">
          <div style="padding: 1rem; background: #FFF;">
            <div class="infor-layout-header mb20">
              <span class="title">蓝牙网关设置</span>
              <el-button
                v-show="checkUserAuth(3, 243)"
                type="primary"
                size="small"
                style="background-color: #3e7878;border-color: #3e7878"
                @click="onAdd">
                添加网关设备
              </el-button>
            </div>
            <div>
              <el-row type="flex" class="row-bg" justify="space-between">
                <el-col :span="18">
                  <el-form
                    ref="formRef"
                    :inline="true"
                    :model="form"
                    size="small">
                    <el-form-item label="设备名称">
                      <el-input v-model.trim="form.gatewayName" style="width: 150px"/>
                    </el-form-item>
                    <el-form-item label="设备mac">
                      <el-input v-model.trim="form.gatewayMac" style="width: 150px"/>
                    </el-form-item>
                    <el-form-item>
                      <el-button @click="onSearch">查询</el-button>
                      <el-button type="primary" @click="onReset">重置</el-button>
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <div style="height:10.25rem;"></div>
        <div class="regional_table">
          <el-table
            v-show="checkUserAuth(3, 244)"
            v-loading.body="tableLoading"
            :height="tableViewHeight"
            :data="tableData"
            width="100%"
            highlight-current-row>
            <el-table-column prop="index" label="序号" align="center">
              <template v-slot="props">
                <span>{{ props.$index + 1 + (formData.pageNum - 1) * formData.pageSize }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="qccid" label="SIM卡号" align="center"/>
            <el-table-column prop="gatewayName" label="设备名称" align="center"/>
            <el-table-column prop="gatewayMac" label="设备mac" align="center"/>
            <el-table-column prop="wifiMac" label="无线mac" align="center"/>
            <el-table-column prop="createByName" label="创建人" align="center"/>
            <el-table-column prop="createTime" label="创建时间" sortable>
              <template v-slot="props">
                <span>{{ props.row.createTime | dateFormat('yyyy-MM-dd hh:mm:ss') }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template v-slot="props">
                <el-button
                  v-show="checkUserAuth(3, 243)"
                  size="mini"
                  @click="onEdit(props.row)">
                  <span>修改</span>
                </el-button>
                <el-button
                  v-show="checkUserAuth(3, 245)"
                  size="mini"
                  type="danger"
                  @click="onDel(props.row)">
                  <span>删除</span>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            v-show="checkUserAuth(3, 244)"
            style="margin-top: 15px; text-align: right"
            @size-change="handleSizeChange"
            @current-change="pageNoChange"
            :current-page="formData.pageNum"
            :page-sizes="pageSizes"
            :page-size="formData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
          <div style="line-height: 50px;margin-left: 10px;" v-show="!checkUserAuth(3, 244)">您的账户没有权限查看此内容！</div>
        </div>
      </div>
    </div>
    <w-dialog
      width="50%"
      ref="w-dialog"
      title="添加网关设备"
      sureBtnText="添加"
      @handleCloseRight="handleCloseDialog"
      @handleClose="handleCloseDialog"
      @onSure="onSave">
      <template v-slot:content>
        <el-form :rules="rules" ref="ruleForm" :model="formDialog" label-width="6.25rem" size="small">
          <el-form-item label="SIM卡号：" prop="qccid">
            <el-input v-model.trim="formDialog.qccid" clearable placeholder="请填写" style="width:40%;"></el-input>
          </el-form-item>
          <el-form-item label="设备名称：" prop="gatewayName">
            <el-input v-model.trim="formDialog.gatewayName" clearable placeholder="请填写" style="width:40%;"></el-input>
          </el-form-item>
          <el-form-item label="设备mac：" prop="gatewayMac">
            <el-input v-model.trim="formDialog.gatewayMac" clearable placeholder="请填写" style="width:40%;"></el-input>
          </el-form-item>
          <el-form-item label="无线mac：" prop="wifiMac">
            <el-input v-model.trim="formDialog.wifiMac" clearable placeholder="请填写" style="width:40%;"></el-input>
          </el-form-item>
          <div id="newSiteMap" style="width:100%;height:400px;"></div>
        </el-form>
      </template>
    </w-dialog>
  </div>
</template>
<script>
import Api from '@/api'
import {
  mapGetters
} from 'vuex'
import WDialog from '@/components/Model/index.vue'
let map = null
export default {
  name: 'gatewayEquipmentConfig',
  components: {
    WDialog
  },
  data() {
    return {
      form: {
        gatewayName: '',
        gatewayMac: ''
      },
      tableViewHeight: 50,
      tableLoading: true,
      tableData: [],
      formData: {
        pageNum: 1,
        pageSize: 20
      },
      pageSizes: [10, 20, 50],
      total: 0,
      formDialog: {},
      rules: {
        qccid: [
          { required: true, message: '请填写SIM卡号', trigger: 'blur' },
          { min: 11, message: 'SIM卡号最小为11位', trigger: 'blur' },
          { max: 20, message: 'SIM卡号最大为20位', trigger: 'blur' }
        ],
        gatewayName: [
          { required: true, message: '请填写设备名称', trigger: 'blur' },
          { validator: this.validateGatewayName, trigger: 'blur' }
        ],
        gatewayMac: [
          { required: true, message: '请填写设备mac', trigger: 'blur' },
          { validator: this.validateGatewayMac, trigger: 'blur' }
        ],
        wifiMac: [
          { required: true, message: '请填写无线mac', trigger: 'blur' },
          { validator: this.validateGatewayMac, trigger: 'blur' }
        ]
      },
      gatewayLon: '', // 设备站点经度
      gatewayLat: '', // 设备站点纬度
      saveStatus: 'add'
    }
  },
  computed: {
    ...mapGetters(['user', 'selfAreaId'])
  },
  created() {
    this.onSearch()
  },
  methods: {
    onAdd() {
      this.saveStatus = 'add'
      this.formDialog = {}
      this.$refs['w-dialog'].onShowDialog()
      this.$nextTick(() => {
        this.initMap()
      })
    },
    onSearch() {
      const params = {
        selfAreaId: this.selfAreaId,
        currentPage: this.formData.pageNum,
        pageSize: this.formData.pageSize,
        gatewayName: this.form.gatewayName,
        gatewayMac: this.form.gatewayMac
      }
      Api.getGatewayEquipment(this.filterEmptyParams(params)).then((res) => {
        this.tableLoading = false
        if (res.code === 200 && res.data) {
          this.tableData = res.data.list
          this.total = res.data.total
        } else {
          this.$message.warning(res.message)
        }
        this.calcView()
      })
    },
    // 过滤空值参数
    filterEmptyParams(params) {
      return Object.fromEntries(
        Object.entries(params).filter(([_, value]) =>
          value !== '' && value !== null && value !== undefined
        )
      )
    },
    pageNoChange(page) {
      this.formData.pageNum = page
      this.onSearch()
    },
    handleSizeChange(size) {
      this.formData.pageSize = size
      this.onSearch()
    },
    onEdit(row) {
      this.saveStatus = 'edit'
      this.formDialog = { ...row }
      this.$refs['w-dialog'].onShowDialog()
      this.$nextTick(() => {
        this.editMap(row)
      })
    },
    onDel(row) {
      this.$confirm('确定要删除【' + row.gatewayName + '】网关设备吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var data = {
          id: row.gatewayId
        }
        Api.delGatewayEquipment(this.selfAreaId, data).then(res => {
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.onSearch()
          } else {
            this.$message.warning(res.message)
          }
        })
      })
    },
    // 初始化地图
    initMap() {
      const mapContainer = document.getElementById('newSiteMap')
      if (!mapContainer) {
        return
      }
      map = new AMap.Map('newSiteMap', {
        resizeEnable: true, // 允许缩放
        zoom: 15 // 设置地图的缩放级别，0 - 20
      })
      map.on('click', (ev) => {
        // 触发事件的地理坐标，AMap.LngLat 类型
        var lnglat = ev.lnglat
        this.gatewayLon = lnglat.getLng()
        this.gatewayLat = lnglat.getLat()
        // 清除原有marker
        map.clearMap()
        // 创建一个 Marker 实例：
        var marker = new AMap.Marker({
          position: new AMap.LngLat(lnglat.getLng(), lnglat.getLat())
        })
        // 将创建的点标记添加到已有的地图实例
        map.add(marker)
      })
    },
    // 修改设备站点标记点
    editMap(row) {
      this.gatewayLon = row.gatewayLon
      this.gatewayLat = row.gatewayLat
      const mapContainer = document.getElementById('newSiteMap')
      if (!mapContainer) {
        return
      }
      const map = new AMap.Map('newSiteMap', {
        resizeEnable: true, // 允许缩放
        zoom: 15, // 设置地图的缩放级别，0 - 20
        center: [row.gatewayLon, row.gatewayLat],
        viewMode: '2D',
        zoomEnable: true, // 是否可滚轮缩放
        dragEnable: true, // 是否可拖拽
        keyboardEnable: false, // 键盘控制'↑' '→' '↓' '←'
        doubleClickZoom: true, // 地图是否可通过双击鼠标放大地图
        showLabel: true,
        expandZoomRange: false,
        pitch: 60, // 3d有效
        showIndoorMap: false
      })
      const marker = new AMap.Marker({
        position: [row.gatewayLon, row.gatewayLat],
        image: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
        imageSize: new AMap.Size(26, 34),
        // 设置是否可以拖拽
        draggable: true,
        cursor: 'move',
        anchor: 'center',
        // 设置拖拽效果
        raiseOnDrag: true
      })
      // 改用箭头函数，确保this指向Vue组件实例 或定义_this = this
      marker.on('dragend', ({ lnglat }) => {
        this.gatewayLon = lnglat.lng
        this.gatewayLat = lnglat.lat
      })
      marker.setMap(map)
    },
    onReset() {
      this.$refs.formRef.resetFields()
      this.form.gatewayName = ''
      this.form.gatewayMac = ''
      this.onSearch()
    },
    onSave() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.gatewayLon === '' || this.gatewayLat === '') {
            this.$message.warning('请新增设备标记点！')
            return
          }
          const params = { ...this.formDialog }
          params.areaId = this.selfAreaId
          params.gatewayLon = this.gatewayLon
          params.gatewayLat = this.gatewayLat
          if (this.saveStatus === 'add') {
            // 新增
            params.createBy = this.user.id
          } else {
            // 修改
            params.updateBy = this.user.id
          }
          Api.saveGatewayEquipment(this.selfAreaId, params).then(res => {
            if (res.code === 200) {
              this.onSearch()
              this.handleCloseDialog()
              this.$message.success(this.saveStatus === 'add' ? '新增成功' : '修改成功')
            } else {
              this.$message.warning(res && res.message)
            }
          })
        }
      })
    },
    validateGatewayName(rule, value, callback) {
      if (value.length < 3 || value.length > 10) {
        return callback(new Error('设备名称长度应在3-10个字符之间'))
      }
      // 校验首尾不能为空格
      if (value.trim() !== value) {
        return callback(new Error('设备名称不能以空格开头或结尾'))
      }
      // 校验特殊字符
      const reg = /^[\u4e00-\u9fa5a-zA-Z0-9_]+$/
      if (!reg.test(value)) {
        return callback(new Error('设备名称只能包含中文、英文、数字、下划线'))
      }
      callback()
    },
    validateGatewayMac(rule, value, callback) {
      const cleanMac = value.replace(/[:]/g, '').toUpperCase()
      if (cleanMac.length !== 12) {
        return callback(new Error('MAC地址格式不正确，应为6个字节（12个字符）'))
      }
      const hexRegex = /^[0-9A-F]{12}$/i
      if (!hexRegex.test(cleanMac)) {
        return callback(new Error('MAC地址包含无效字符，只允许0-9、A-F、a-f'))
      }
      callback()
    },
    handleCloseDialog() {
      this.$refs['w-dialog'].onCloseDialog()
    },
    calcView() {
      this.$nextTick(() => {
        let H = 0
        if (this.$refs.searchBox && this.$refs.searchBox.clientHeight) {
          H += Number(this.$refs.searchBox.clientHeight)
        }
        // 56: 导航栏高度修正
        // 79: table分页器高度修正
        this.tableViewHeight = window.innerHeight - 56 - H - 96 - 20
      })
    }
  }
}
</script>

<style lang="less" scoped>
.device-setting {
  background: rgba(240, 242, 245, 1);
  width: 100%;
  height: 100%;
  overflow-y: scroll;
}
.device {
  #echarts {
    width: 780px;
    height: 400px;
  }
}
.device .el-table .cell {
  padding-right: 0;
  padding-left: 0;
}
.table-container{
  background-color: white;
}
.regional_table {
  margin: 0 10px 24px 15px;
  padding-bottom: 10px;
  box-sizing: border-box;
  background-color: #fff;
}
</style>
